import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 20.255c4.97 0 9-3.694 9-8.25 0-4.557-4.03-8.25-9-8.25s-9 3.693-9 8.25c0 2.103.859 4.023 2.273 5.48.432.446.74 1.039.586 1.64a4.5 4.5 0 0 1-.923 1.786A6 6 0 0 0 6 21.005c1.282 0 2.47-.402 3.445-1.087.81.219 1.668.337 2.555.337"
    }, null, -1)
  ])))
}
export default { render: render }